import React from 'react';
import WorkerUtil from "../../../../../../utils/orders/WorkerUtil";

const CellWJTFCs= ({cell}) => {
    return (
        <span> {WorkerUtil.convertWorker(cell.getValue())}</span>
    );
};

export default CellWJTFCs;